import ModalWrapper from '../../../common/Modal/ModalWrapper';

const DeleteModuleModal = ({ moduleName, onConfirm, onClose }) => {
    const handleConfirm = () => {
        onConfirm();
        if (typeof onClose === 'function') onClose();
    };

    return (
        <ModalWrapper
            modalType="confirmDeleteModuleSection"
            onCloseHandler={onClose}
            modalCardClasses="m1rem maw600px"
            customStyle={{ padding: '2rem', zIndex: 9, marginTop: '2rem' }}
        >
            <h1 className="c15 fs2rem tac lh1 fw600 mb2rem">
                Confirm Deletion
            </h1>
            <div className="df fdc aic mb2rem">
                <p className="fs1-25rem c15 fw400 tac mb1rem">
                    Are you sure you want to delete this module?
                </p>
                <p className="fs1rem c4 fw600">
                    {moduleName}
                </p>
                <p className="fs0-75rem c15">
                    This action cannot be undone.
                </p>
            </div>
            <div className="df jcc gg1rem">
                <span
                    onClick={onClose}
                    className="bo4 bss bg1 bg4-hover c4 c1-hover td250 br20px p1rem fw600 cp w30 ttu bsbb tac df jcc aic mr0-5rem"
                >
                    Cancel
                </span>
                <span
                    onClick={handleConfirm}
                    className="bg3 bo3 bss bo4-hover bg4-hover c1 td250 br20px p1rem fw600 w30 cp ttu bsbb tac df jcc aic ml0-5rem"
                >
                    Delete Module
                </span>
            </div>
        </ModalWrapper>
    );
};

export default DeleteModuleModal;
